export default {

  isAuthenticated(state) {
    return state.isAuthenticated;
  },
  uId(state) {
    return state.uId;
  },
  token(state) {
    return state.token;
  },


  today(state) {
    return state.today;
  },
  todayActual(state) {
    return state.todayActual;
  },
  tomorrowActual(state) {
    return state.tomorrowActual;
  },
  todaysDateDisplay(state) {
    return state.todaysDateDisplay;
  },
  dayOfWeek(state) {
    return state.dayOfWeek;
  },


  reasons(state) {
    return state.reasons;
  },
  program(state) {
    return state.program;
  },

};
